interface SEOSchemaProps {
  type: 'WebPage' | 'Article' | 'FAQPage' | 'Organization';
  data: Record<string, unknown>;
}

export default function SEOSchema({ type, data }: SEOSchemaProps) {
  const baseData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(baseData)}
    </script>
  );
}